import { createContext, useContext, useMemo, useState } from "react";

const CameraContext = createContext(null);

export function CameraProvider({ cameras = [], streamStatus = {}, children }) {
  const [viewMode, setViewMode] = useState("grid");
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  const [logCamera, setLogCamera] = useState(null);

const filteredCameras = useMemo(() => {
  let list = cameras;

  // 🔘 Status filter
  if (filterStatus === "inactive") {
    list = list.filter((c) => !c.is_active);
  }

  if (filterStatus === "online") {
    list = list.filter(
      (c) => c.is_active && streamStatus[c.id] === "online"
    );
  }

  if (filterStatus === "offline") {
    list = list.filter(
      (c) => c.is_active && streamStatus[c.id] !== "online"
    );
  }

  // 🔍 Search filter
  if (search) {
    const q = search.toLowerCase();
    list = list.filter(
      (c) =>
        c.name?.toLowerCase().includes(q) ||
        c.ip_address?.includes(q)
    );
  }

  return list;
}, [cameras, streamStatus, search, filterStatus]);



  return (
    <CameraContext.Provider
      value={{
        cameras,
        filteredCameras,
        streamStatus,

        viewMode,
        setViewMode,

        search,
        setSearch,

        filterStatus,
        setFilterStatus,

        logCamera,
        setLogCamera,
      }}
    >
      {children}
    </CameraContext.Provider>
  );
}

export function useCameraContext() {
  const ctx = useContext(CameraContext);
  if (!ctx) {
    throw new Error("useCameraContext must be used inside CameraProvider");
  }
  return ctx;
}

